import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getKPIIndicatorAvailableColumns } from './api';

export const path = '/kpi-indicator/list';

const PageKPIIndicator: React.FC = (props) => {
  const KPIIndicator = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getKPIIndicatorAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <KPIIndicator {...props} />;
};

export default PageKPIIndicator;
